import InstanceListPage from '../components/InstanceListPage/InstanceListPage';
import { InstanceListType } from '../utils/models';

export default function InstancePage() {
  return <InstanceListPage type={InstanceListType.my} />;
}
